import React, {
  KeyboardEvent as KeyboardSyntheticEvent,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
} from 'react';

import { useStyles } from './ecp-store.styles';
import { IEcpStoreProps } from './ecp-store.models';
import { isYMEnabled, pushStoreCode } from '../../../../utils';
import { StoreInfo } from '../../../common';

export const EcpStore = ({
  storeData,
  onStoreSelect,
  storeCode,
  onScrollToStore,
  contentStyles,
  contentPartialStyles,
  titleStyles,
}: IEcpStoreProps): JSX.Element => {
  const classes = useStyles();
  const {
    name,
    rating,
    type,
    distance,
    street,
    openinghours,
    phonenumber,
    code,
    detailedLocation,
  } = storeData;

  const phoneEl = useRef<HTMLAnchorElement>(null);
  const titleEl = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    onScrollToStore(code, titleEl, storeCode);
  }, [storeCode]);

  const handleKeyPress = useCallback((event: KeyboardSyntheticEvent) => {
    if (phoneEl.current !== event.target
      && (event.code === 'Enter' || event.code === 'Space')) {
      event.preventDefault();
      onStoreSelect(storeData);
    }

    if (isYMEnabled() && !!code) {
      pushStoreCode(code);
    }
  }, [onStoreSelect]);

  const handleClick = useCallback((event: SyntheticEvent) => {
    if (phoneEl.current !== event.target) {
      onStoreSelect(storeData);
    }

    if (isYMEnabled() && !!code) {
      pushStoreCode(code);
    }
  }, [onStoreSelect]);

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={0}
      data-testid="store"
    >
      <span
        className={classes.arrowRight}
        data-testid="arrow-right-button"
        aria-hidden="true"
      />
      <StoreInfo
        name={name}
        rating={rating}
        type={type}
        distance={distance}
        street={street}
        detailedLocation={detailedLocation}
        phonenumber={phonenumber}
        openinghours={openinghours}
        titleStyles={titleStyles}
        contentStyles={contentStyles}
        contentPartialStyles={contentPartialStyles}
      />
    </div>
  );
};
